/*
 * File: POReceiptFilters.ts
 * Project: mdsi-template-app
 * -----
 * Last Modified: 24 May 2021 5:32:23 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */
export enum POReceiptFilters {
  MDSI_PO_NUMBER = 'MDSI P.O Number',
  CUST_PO_NUMBER = 'Customer P.O. Number',
  VENDOR_ACCOUNT = 'Vendor Account',
  VENDOR_NAME = 'Vendor Name',
  WAREHOUSE = 'Warehouse'
}
